import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.seek.com',
    clientDomain: 'sg.employer.seek.com',
    clientId: 'pLU3sbg62iNCSQN8oqrFPYPgmJsSPUpS',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://www.jobstreet.com/about-us/contact-us-singapore/',
    },
    siteName: siteNames.employer.seek.sg,
    zone: getZoneFromSite(siteNames.employer.seek.sg),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=sg_employer_seek_com.js.map